// extracted by mini-css-extract-plugin
export default {"skeleton-line--m":"J59B9","skeleton-line--l":"Zeh9r"};